export default {
    data: () => ({
        orderModel: {
            firstname: '',
            lastname: '',
            birthdate: '',
            gender: '',
            phone: '',
            email: '',
            delivery: 0,
            lending_point_id: null,
            lending_kit_id: null,
            origin_id: null,
            consumer_type_id: null,
            address: '',
            address_2: '',
            city: '',
            zipcode: '',
            follow_up: null,
            is_sold: false,
            device: '',
            referer: '',
            observations: '',
            no_sold_reason_id: null,
            no_sold_reason: '',
            pickup_phone: '',
            pickup_address: '',
            pickup_address_2: '',
            pickup_city: '',
            pickup_zipcode: '',
            sell_order_number: '',
            iqos_user_id: '',
            iqos_group_updated: false,
            legal_age: false,
            employee: null,
            devices: [],
            kit_model: null,
            nif:''
            //kit_color: null,
        }
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/orderModel.js